import {JourneyStatus} from '@/types/JourneyStatus'
// import {Tag} from 'pepsico-ds'
import {useMemo} from 'react'
import {useIntl} from 'react-intl'

type JourneyStatusBadgeProps = {
  status: JourneyStatus
}

export const JourneyStatusBadge = ({status}: JourneyStatusBadgeProps) => {
  const {formatMessage} = useIntl()
  const label = formatMessage({id: `STATUS.${status}`})

  const normalizedStatus = useMemo(() => {
    switch (status) {
      case JourneyStatus.new:
      case JourneyStatus.draft:
      case JourneyStatus.saved:
        return JourneyStatus.draft
      default:
        return status
    }
  }, [status])

  return (
    <span data-testid={`journey-status-${normalizedStatus}-badge`}>
      {/* <Tag
        data-cy={`journey-status-${normalizedStatus}-badge`}
        // color="default"
        // type="faded"
        className={`journey-status-${normalizedStatus}-badge`}
        size="large"
        text={label}
        isCopyable={false}
        isRemovable={false}
      /> */}
      <div
        data-cy={`journey-status-${normalizedStatus}-badge`}
        className={`journey-status-${normalizedStatus}-badge inline-flex items-center rounded px-2 py-1 text-sm font-medium`}
      >
        {label}
      </div>
    </span>
  )
}
